var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NeuroStandardsTimeline',{attrs:{"api-base":"https://api.yubinglabs.com/web/neuro/neuro_standards","months":[1,2,3,4,5,6],"domain-order":['大运动','精细动作','适应能力','语言','社会行为','交流互动警示行为'],"initial-month":_vm.initialMonth,"is-paid":_vm.isPaid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }